import { type DynamicResource, notifyDynamicResourceLoad } from '#i18n/LazyResourceBackend'
import { sharedResources } from '#i18n/resources/resources'

if (import.meta.hot) {
  import.meta.hot.accept('./de/translation.json', (module) => notifyDynamicResourceLoad('de', 'translation', module))
  import.meta.hot.accept('./dev/translation.json', (module) => notifyDynamicResourceLoad('dev', 'translation', module))
  import.meta.hot.accept('./en/translation.json', (module) => notifyDynamicResourceLoad('en', 'translation', module))
  import.meta.hot.accept('./it/translation.json', (module) => notifyDynamicResourceLoad('it', 'translation', module))
}

export const resources = {
  de: {
    translation: () => import('./de/translation.json'),
    shared: sharedResources.de.shared,
  },
  dev: {
    translation: () => import('./dev/translation.json'),
    shared: sharedResources.dev.shared,
  },
  en: {
    translation: () => import('./en/translation.json'),
    shared: sharedResources.en.shared,
  },
  it: {
    translation: () => import('./it/translation.json'),
    shared: sharedResources.it.shared,
  },
} as const satisfies DynamicResource

export const namespaces = ['translation', 'shared'] as const
